export const scrollToModalPart = (partKey: string): void => {
  const target = document.getElementById(
    `modal-part-id-${partKey}`,
  ) as HTMLElement;
  const container = target?.closest(".modal-body") as HTMLElement;
  if (target && container) {
    container.scrollTo({
      top: target.offsetTop - container.offsetTop,
      behavior: "smooth",
    });
  }
};
